<template>
  <div>
    <!-- Page Header -->
    <div class="mb-5">
      <div class="headline saPrimary--text">
        {{ $t("company.personal_info.title") }}
      </div>
    </div>

    <!-- Page content -->
    <v-card v-if="company" class="mb-3">
      <v-card-title primary-title>
        <div>
          <div class="title">
            {{ company.title }}
            <v-chip
              v-if="company.is_screening_pricing_enterprise"
              small
              color="saPrimary"
              outline
              class="ma-0 pa-0"
              ><b>{{ $t("enterprise.title") }}</b></v-chip
            >
          </div>
          <div v-if="company.owner" class="subheading greyDarken2--text pt-1">
            {{ company.owner.email }}
          </div>
        </div>
        <v-spacer></v-spacer
        ><v-btn
          class="my-0"
          dark
          depressed
          color="saPrimaryDarker1"
          @click.stop="updateCompany()"
          >{{ $t("rms.button.save") }}</v-btn
        ><v-btn
          class="ma-0"
          dark
          depressed
          color="grey"
          @click.stop="goToListPage()"
          >{{ $t("rms.button.cancel") }}</v-btn>
          <span class="mx-2 greyDarken1--text">|</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                color="red"
                dark
                v-on="on"
                class="mx-0 pr-1"
              >Logout
              <v-icon class="ma-0 pa-0">$vuetify.icons.screener_menu_down</v-icon>
              </v-btn>
            </template>
            <v-list>
               <v-list-tile @click="confirmCompanyMembersLogout(null)">
                <v-list-tile-title>All Members</v-list-tile-title>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile
                v-for="(role, index) in DEFINES.COMPANY_USER_ROLE"
                :key="index"
                @click="confirmCompanyMembersLogout(role)"
              >
                <v-list-tile-title>{{ role.text }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <!-- Basic info -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("screener.basic_info.title") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("screener.admin.company.basic_info.subtitle") }}
            </div> </v-flex
          ><v-flex xs12 md9>
            <BasicInfo :company.sync="company"></BasicInfo>
          </v-flex>
        </v-layout>

        <!-- Enterprise Setting -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("screener.admin.company.enterprise.setting.title") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("screener.admin.company.enterprise.setting.subtitle") }}
            </div></v-flex
          ><v-flex xs12 md9>
            <EnterpriseSetting :company.sync="company"></EnterpriseSetting>
          </v-flex>
        </v-layout>

        <!-- Monetization -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("screener.admin.company.monetization") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("screener.admin.company.monetization.subtitle") }}
            </div></v-flex
          ><v-flex xs12 md9>
            <MonetizationSetting :company.sync="company"></MonetizationSetting>
          </v-flex>
        </v-layout>

        <!-- VOD Setting -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("vod.admin.company.setting") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("vod.admin.company.setting.description") }}
            </div></v-flex
          ><v-flex xs12 md9>
            <VodSetting :company.sync="company"></VodSetting>
          </v-flex>
        </v-layout>

         <!-- Physical event Setting -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("admin.physical.event.setting") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("admin.physical.event.setting.description") }}
            </div></v-flex
          ><v-flex xs12 md9>
            <PhysicalEventSetting :company.sync="company"></PhysicalEventSetting>
          </v-flex>
        </v-layout>

        <!-- Affiliation Setting -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
            {{$t('screener.admin.company.affiliation_setting.title')}}
            </div>
            <div class="greyDarken3--text body-1">
             {{$t('screener.admin.company.affiliation_setting.subtitle')}}
            </div></v-flex
          ><v-flex xs12 md9>
            <AffiliationSetting :company.sync="company"></AffiliationSetting>
          </v-flex>
        </v-layout>

        <!-- Revenue -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("screener.admin.company.revenue.title") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("screener.admin.company.revenue.subtitle") }}
            </div></v-flex
          ><v-flex xs12 md9>
            <RevenueSummary class="pb-3" :isSAPanel="true" :companyId="company.id"></RevenueSummary>
          </v-flex>
        </v-layout>

        <!-- Payment Method -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("screener.admin.company.payment_method.title") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("screener.admin.company.payment_method.subtitle") }}
            </div> </v-flex
          ><v-flex xs12 md9>
            <v-list
              v-if="company.card_brand && company.card_last_four"
              two-line
              class="border-grey-all"
            >
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{
                    company.card_brand.toUpperCase()
                  }}</v-list-tile-title>
                  <v-list-tile-sub-title class="py-1"
                    >●●●●●●●●{{ company.card_last_four }}</v-list-tile-sub-title
                  >
                  <v-list-tile-sub-title
                    ><b>{{ $t("default.title") }}!</b
                    ><span>
                      {{ $t("default_payment_mthd.info") }}</span
                    ></v-list-tile-sub-title
                  >
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-layout v-else justify-center text-xs-center>
              <div class="greyDarken2--text pa-4">
                <div class="title">{{ $t("no_payment_method.title") }}</div>
              </div>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- Payment Gateway Setting -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{$t('screener.payment_setting.title')}}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("admin.physical.event.setting.description") }}
            </div></v-flex
          ><v-flex xs12 md9>
            <PaymentGatewaySetting ref="gatewaySettingForm" :company.sync="company"></PaymentGatewaySetting>
          </v-flex>
        </v-layout>

        <!-- Facebook Pixel -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("screener.admin.company.facebook_pixel") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("screener.admin.company.facebook_pixel.tooltip") }}
            </div></v-flex
          ><v-flex xs12 md9>
            <v-text-field
              v-model="company.custom_properties.fbpixelId"
              color="saPrimary"
              :label="$t('rms.field.fbpixelId.label')"
              placeholder="Facebook Pixel Id"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <!-- MailChimp Setting -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("screener.admin.company.newsletter_mc") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("screener.admin.company.newsletter_mc.tooltip") }}
            </div></v-flex
          ><v-flex xs12 md9>
            <v-text-field
              v-model="company.custom_properties.mcApiKey"
              color="saPrimary"
              :label="$t('rms.field.mcApiKey.label')"
              placeholder="MailChimp API key"
              @input="getMailchimpLists"
              :hint="$t('screener.admin.company.newsletter_mc.hint')"
            ></v-text-field>
            <v-select
              v-model="company.custom_properties.mcListId"
              :items="mailchimpLists"
              item-text="name"
              item-value="id"
              color="saPrimary"
              :label="$t('rms.field.mcListId.label')"
              placeholder="MailChimp List"
              :rules="
                company.custom_properties.mcApiKey ? [rules.required] : []
              "
            ></v-select>
          </v-flex>
        </v-layout>

        <!-- Theme Configuration -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("screener.admin.company.theme_configuration") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("screener.admin.company.theme_configuration.tooltip") }}
            </div></v-flex
          ><v-flex xs12 md9>
            <ThemeConfiguration :company.sync="company"></ThemeConfiguration>
          </v-flex>
        </v-layout>
        <!-- Audience Registration -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("screener.admin.company.audience_registration") }}
            </div> </v-flex
          ><v-flex xs12 md9>
            <AudienceRegistration
              :company.sync="company"
            ></AudienceRegistration>
          </v-flex>
        </v-layout>

        <!-- Support -->
        <v-layout row wrap class="mb-3">
          <v-flex xs12 md3 class="pr-2 pb-2">
            <div class="headline saSecondary--text">
              {{ $t("screener.admin.company.support") }}
            </div>
            <div class="greyDarken3--text body-1">
              {{ $t("screener.admin.company.support.tooltip") }}
            </div></v-flex
          ><v-flex xs12 md9>
            <v-text-field
              v-model="company.custom_properties.support.email"
              color="saPrimary"
              :rules="[rules.email]"
              :label="$t('rms.field.email.label')"
              placeholder="Email"
            ></v-text-field>
            <v-text-field
              v-model="company.custom_properties.support.phone"
              color="saPrimary"
              type="number"
              :label="$t('rms.table.header.phone')"
              placeholder="+911234567890"
              :hint="$t('screener.admin.company.support.phone.hint')"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn
          class="my-0 mx-2"
          dark
          depressed
          color="saPrimaryDarker1"
          @click.stop="updateCompany()"
          >{{ $t("rms.button.save") }}</v-btn
        ><v-btn
          class="ma-0"
          dark
          depressed
          color="grey"
          @click.stop="goToListPage()"
          >{{ $t("rms.button.cancel") }}</v-btn
        >
      </v-card-actions>
    </v-card>

    <!-- Add ons -->
    <v-card class="mb-3" v-if="company && company.addons">
      <v-card-title>
        <h3 class="saSecondary--text">{{$t('rms.sa.addon.title')}}</h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        dense
        :headers="headers"
        :items="Object.values(company.addons)"
        hide-actions
      >
        <template v-slot:items="props">
          <tr>
            <td class="body-1">
              {{ __getAddonNameById(props.item.id) }}
            </td>
            <td class="body-1">
              {{ props.item.used }}&nbsp;/&nbsp;{{
                props.item.quantity
              }}
            </td>
            <td class="body-1">
              <b
                >{{
                  DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL
                }}{{ props.item.amount }}</b
              >
            </td>
            <td>
              {{
                moment
                  .utc(props.item.created_at)
                  .local()
                  .format("Do MMM YYYY, hh:mm")
              }}
            </td>
            <td>
              <v-btn
                :disabled="props.item.used >= props.item.quantity"
                class="my-0"
                outline
                small
                depressed
                color="saPrimaryDarker1"
                @click="consume(props.item)">
                {{$t('rms.btn.consume')}}
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>

      <!-- Consume dialog -->
      <v-dialog v-model="consumeDialog" persistent max-width="700">
        <v-card  v-if="selectedAddOn" class="pa-3">
          <v-card-title class="title">
           {{ __getAddonNameById(selectedAddOn.id) }}
            <v-spacer></v-spacer>
        <v-btn
          class="mx-0"
          small
          dark
          icon
          color="grey"
          @click="consumeDialog = false"
        >
          <v-icon small>$vuetify.icons.rms_close</v-icon>
        </v-btn>
          </v-card-title>

          <v-card-text
            class="subheading"
            primary-title
          >
            <v-layout row wrap>
              <v-flex xs12 md7>
                <h3 class="subheading">
                   {{$t('rms.addon.consume_total')}}
                </h3>
              </v-flex>
              <v-flex xs12 md4 class="text-md-right title">
                {{ company.addons[this.selectedAddOn.id].used }}&nbsp;/&nbsp;
                {{ company.addons[this.selectedAddOn.id].quantity }}
              </v-flex>
            </v-layout>
            <v-layout row wrap class="py-2">
               <v-flex xs12 md7>
                <h3 class="subheading">
                    {{$t('rms.addon.available_to_use')}}
                </h3>
              </v-flex>
              <v-flex xs12 md4 class="text-md-right title">
                {{addOnMaxLimit}}
              </v-flex>
            </v-layout>

             <v-divider></v-divider>
            <v-layout row wrap class="pt-4">
              <v-flex xs12 md7>
                <h3 class="subheading">
                    {{$t("rms.addon.add_to_consume")}}
                </h3>
              </v-flex>
              <v-flex xs12 md4 class="text-md-right">
                <integer-plusminus
                  :min="1"
                  :max="addOnMaxLimit"
                  :step="1"
                  v-model="selectedAddOn.quantity"
                  class="d-inline-flex"
                >
                </integer-plusminus>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="py-2">
              <v-flex xs12 md12>
                <v-textarea
                  outline
                  label="Add Comment"
                  v-model="selectedAddOn.comment"
                />
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              outline
              @click="consumeDialog = false"
            >
              {{ $t("rms.button.cancel") }}
            </v-btn>
            <v-btn
              color="primary"
              outline
              @click="onConsume()"
            >
              {{ $t("rms.button.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <!-- Members -->
    <v-card v-if="company">
      <v-card-title>
        <h3 class="saSecondary--text">{{ $t("company.members.title") }}</h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <Members :company="company"></Members>
    </v-card>
    <ConfirmationDialog
      v-if="logoutConfirmationDialog"
      :dialog="logoutConfirmationDialog"
      @confirm="logoutCompanyMembers(roleToBeLoggedOut)"
      @cancel="resetLogoutConfirmationDialog()"
    ></ConfirmationDialog>
  </div>
</template>

<script>
import i18n from "@/i18n";
import rules from "@/validation";
import DEFINES from "@/defines";
import { mapState, mapGetters } from "vuex";
import { getCurrencySymbol } from "@/helper";
import BasicInfo from "@/components/admin/company/profile/BasicInfo";
import ThemeConfiguration from "@/components/admin/company/profile/ThemeConfiguration";
import AudienceRegistration from "@/components/admin/company/profile/AudienceRegistration";
import MonetizationSetting from "@/components/admin/company/profile/MonetizationSetting";
import RevenueSummary from "@/components/revenue/RevenueSummary";
import VodSetting from "@/components/admin/company/profile/VodEventSetting";
import PhysicalEventSetting from "@/components/admin/company/profile/PhysicalEventSetting";
import ExistingPaymentMethod from "@/components/ExistingPaymentMethod";
import Members from "@/components/admin/company/profile/Members";
import EnterpriseSetting from "@/components/admin/company/profile/EnterpriseSetting";
import AffiliationSetting from "@/components/admin/company/profile/AffiliationSetting";
import { IntegerPlusminus } from "vue-integer-plusminus";
import PaymentGatewaySetting from "@/components/company/PaymentGatewaySetting";
import ConfirmationDialog from '@/components/dialogBox/Confirmation';

export default {
  name: "AdminCompanyProfile",
  data() {
    return {
      rules,
      company: null,
      local_meta_info: {
        keywords: null,
      },
      local_custom_properties: {
        is_rtl: this.DEFINES.THEME.PLATFORM.RTL,
        theme: {
          primaryColor: DEFINES.THEME.PLATFORM.COLORS.PRIMARY,
          secondaryColor: DEFINES.THEME.PLATFORM.COLORS.SECONDARY,
          backgroundColor: DEFINES.THEME.PLATFORM.COLORS.BACKGROUND,
        },
        language: this.DEFINES.THEME.PLATFORM.LOCALE,
        timezone: this.momentTz.tz.guess(true),
        support: {
          email: DEFINES.SUPPORT_EMAIL,
          phone: null,
        },
        revenue_calculation_time:
          DEFINES.MONETIZATION.CALCULATE_REVENUE_AFTER_HOURS,
        booking_revenue_calculation_time:
          DEFINES.MONETIZATION.CALCULATE_REVENUE_AFTER_HOURS,
        mcApiKey: null,
        mcListId: []
      },
      local_reg_configuration: {
        reminder_time: 60,
        verification_required: false,
        mobile_required: false,
        send_reminder: true,
        is_mobile_visible: true,
      },
      mailchimpLists: null,
      consumeDialog: false,
      selectedAddOn: null,
      headers: [
        {
          text: this.$t('addon.table_header.title'),
          align: "left",
          sortable: false,
          value: "title",
        },
        {
          text: this.$t('addon.table_header.quantity'),
          align: "left",
          sortable: false,
          value: "used",
        },
        {
          text: this.$t('addon.table_header.amount'),
          align: "left",
          sortable: false,
          value: "amount",
        },
        {
          text: this.$t('addon.table_header.created_at'),
          align: "left",
          sortable: false,
          value: "created_at",
        },
        {
          text: 'Action',
          align: "left",
          sortable: false,
        },
      ],
      logoutConfirmationDialog:false,
      roleToBeLoggedOut:null
    };
  },
  components: {
    BasicInfo,
    ThemeConfiguration,
    AudienceRegistration,
    MonetizationSetting,
    ExistingPaymentMethod,
    Members,
    EnterpriseSetting,
    IntegerPlusminus,
    VodSetting,
    PhysicalEventSetting,
    MonetizationSetting,
    RevenueSummary,
    AffiliationSetting,
    PaymentGatewaySetting,
    ConfirmationDialog
  },
  mounted() {
    this.getCompany();
  },
  computed:{
    addOnMaxLimit: function(){
     let addOn = this.company.addons[this.selectedAddOn.id]
     return addOn.quantity - addOn.used;
    }
  },

  methods: {
    async logoutCompanyMembers(role)
    {
      try {
        var response = await this.$store.dispatch("adminCompany/logoutMembers",{
          role: role ? role.value: role,
          id:this.company.id
        });
        var message = role ? `All members with the role of ${role.text} have been logged out.` :'All members have been logged out.'
        this.$store.dispatch("app/showMessage", {
          message: message,
          color: "success",
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }finally{
        this.resetLogoutConfirmationDialog();
      }
    },
    confirmCompanyMembersLogout(role){
      this.roleToBeLoggedOut = role;
      this.logoutConfirmationDialog = true;
    },
    resetLogoutConfirmationDialog(){
      this.roleToBeLoggedOut = null;
      this.logoutConfirmationDialog = false;
    },
    consume(addOn){
      this.selectedAddOn = this.DEFINES.SCREENING_ADD_ONS.find(
        (addon) => addon.id === addOn.id
      );
      this.selectedAddOn.quantity = 1;
      this.selectedAddOn.comment = '';
      this.consumeDialog = true;
    },
    async onConsume(){
      try {
        await this.$store.dispatch(
          "adminCompany/consumeAddOns", {
            companyId: this.company.id,
            addOnId: this.selectedAddOn.id,
            addOnQuantity: this.selectedAddOn.quantity,
            comment: this.selectedAddOn.comment
          });

        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.updated"),
          color: "success",
        });
        this.consumeDialog = false;
        this.getCompany()
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }

    },
    __getAddonNameById(addonId) {
      let aon = this.DEFINES.SCREENING_ADD_ONS.find(
        (addon) => addon.id === addonId
      );
      return aon.title;
    },

    async getMailchimpLists() {
      if (
        this.company.custom_properties.mcApiKey &&
        this.company.custom_properties.mcApiKey.length &&
        this.company.custom_properties.mcApiKey.length < 25
      ) {
        return (this.company.custom_properties.mcListId = "");
      }
      try {
        let response = await this.$store.dispatch("company/getMailchimpLists", {
          apiKey: this.company.custom_properties.mcApiKey,
        });
        this.mailchimpLists = response;
      } catch (error) {
        this.mailchimpLists = null;
        // console.log(error.message);
      } finally {
        // set mcListId null if not exist in updated list
        if (this.company.custom_properties.mcListId) {
          var found = this.mailchimpLists
            ? this.mailchimpLists.some(
                (list) => list.id == this.company.custom_properties.mcListId
              )
            : false;
          if (!found) this.company.custom_properties.mcListId = "";
        }
      }
    },

    getCurrencySymbol() {
      return getCurrencySymbol(this.currency);
    },

    async getCompany() {
      if (this.$route.params.company_id == undefined) {
        return;
      }
      try {
        var resposnse = await this.$store.dispatch("adminCompany/get", {
          id: this.$route.params.company_id,
        });
        var company = Object.assign({}, resposnse);

        if (!company.meta_info) {
          company.meta_info = this.local_meta_info;
        } else {
          company.meta_info = this.setNonDefinedProperties(
            this.local_meta_info,
            company.meta_info
          );
        }
        if (!company.custom_properties) {
          company.custom_properties = this.local_custom_properties;
        } else {
          company.custom_properties = this.setNonDefinedProperties(
            this.local_custom_properties,
            company.custom_properties
          );
        }
        if (!company.reg_configuration) {
          company.reg_configuration = this.local_reg_configuration;
        } else {
          company.reg_configuration = this.setNonDefinedProperties(
            this.local_reg_configuration,
            company.reg_configuration
          );
        }
        this.company = company;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },
    async updateCompany() {
      if (!this.$refs.gatewaySettingForm.validate()) {
        return false;
      }

      try {
        var response = await this.$store.dispatch(
          "adminCompany/update",
          this.company
        );

        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.updated"),
          color: "success",
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    goToListPage() {
      this.$router.push({ name: "AdminCompaniesList" });
    },
    setNonDefinedProperties(parentObj, childObj) {
      for (const key in parentObj) {
        if (!childObj.hasOwnProperty(key)) {
          childObj[key] = parentObj[key];
        }
      }
      return childObj;
    },
  },
};
</script>

<style></style>
